import { render, staticRenderFns } from "./ostatok_kassa.vue?vue&type=template&id=1580066c&"
import script from "./ostatok_kassa.vue?vue&type=script&lang=js&"
export * from "./ostatok_kassa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports